import { DARK_SURFACE } from 'utilities/constants/colors';

export const SUPPLY_NODE_WIDTH = 327;
export const SUPPLY_NODE_HEIGHT = 123;
export const SUPPLY_NODE_HEIGHT_IA = 163;
export const SUPPLY_H_GAP = 300;
export const SUPPLY_V_SPACING = 30;
export const SUPPLY_GRAPH_HEIGHT = 700;

export const SUPPLY_CARD_ICON_SIZE = 32;
export const SUPPLY_CARD_ICON_GAP = 12;
export const SUPPLY_CARD_TEXT_INDENT = SUPPLY_CARD_ICON_SIZE + SUPPLY_CARD_ICON_GAP;

export const SUPPLY_CARD_PADDING_X = 16;
export const SUPPLY_CARD_PADDING_Y = 12;
export const SUPPLY_CARD_BORDER_WIDTH = 1;
export const SUPPLY_CARD_ACCENT_WIDTH = 6;
export const SUPPLY_CARD_PADDING_LEFT_HIGHLIGHTED = SUPPLY_CARD_PADDING_X + SUPPLY_CARD_ACCENT_WIDTH - SUPPLY_CARD_BORDER_WIDTH;

export const DIM_OPACITY = 0.45;

export const COLORS = {
  greenLight: '#48BB78',
  greenDark: '#68D391',
  expandGreenLight: '#2EA266',
  expandGreenDark: '#268654',
  linkGreenDark: '#4ADE80',
  expandBgLight: '#F6FDF9',
  expandBgDark: '#D0F3E1',
  badgeOuterDark: '#393636',
  collapseBgLight: '#FED7D7',
  collapseBgDark: '#FEB2B2',
  collapseRed: '#E53E3E',
  purpleLight: '#9F7AEA',
  purpleDark: '#B794F4',
  datasetBlueLight: '#4299E1',
  rootOutline: '#3F59DC',
  inputBorder: '#5CD496',
  grayDim: '#AEACAC',
  grayDark: '#575454',
  borderLight: '#E7E7E7',
  buttonOutlinedBorderDark: 'rgba(255, 255, 255, 0.08)',
  textLight: '#231F1F',
  textDark: '#E2E8F0',
  darkSurface: DARK_SURFACE,
  secondaryCtaBgLight: 'rgba(255, 255, 255, 0.04)',
  hoverLabelBgLight: '#C6F6D5',
  hoverLabelBgDark: '#276749',
  hoverLabelColorLight: '#276749',
  hoverLabelColorDark: '#C6F6D5',
  hoverConsumerLineLight: '#805AD5',
  hoverConsumerLineDark: '#B794F4',
  hoverConsumerLabelBgLight: '#D6BCFA',
  hoverConsumerLabelBgDark: '#44337A',
  hoverConsumerLabelColorLight: '#44337A',
  hoverConsumerLabelColorDark: '#D6BCFA',
};

export const FUNCTIONAL_ACCENT_LIGHT = '#393636';
export const FUNCTIONAL_ACCENT_DARK = '#E7E7E7';
